import { useEffect, useRef, useState } from "react";
import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { Form, Input, Button, Switch, Select, message, Checkbox, Row, Col } from "antd";
import bgDesktopVideo from '../assets/videos/bg-desktop.mp4'

import './confirmation.css'
const { Option } = Select;

export const Contact = (props) => {
  const [loading, setLoading] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [videoHeight, setVideoHeight] = useState('100%')
  const formRef = useRef(null);
  const contactRef = useRef(null);

  useEffect(() => {
    if (!formRef.current || !contactRef.current) return;

    const updateHeight = () => {
      const headerHeight = formRef.current.offsetHeight;
      // setVideoHeight(headerHeight + 300)

      contactRef.current.style.height = `${headerHeight + 50}px`;
    };

    // Initial set
    updateHeight();

    // Observe size changes
    const observer = new ResizeObserver(() => {
      updateHeight();
    });

    observer.observe(contactRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);
  const onFinish = (values) => {
    setLoading(true); // Start loading
    const { rsvp, name, email, phoneNumber,designation, ...rest } = values;
    const signUpData = {
      firstName: name,
      email: email,
      mobile: phoneNumber,
      designation:designation,
      additionalDetails: {
        rsvp:true,
        designation:designation,
        ...rest,
      },
    };

    fetch("https://flipkart-connect-26.wiz365.io/api/auth/signup-wizit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(signUpData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("Success:", data);
        messageApi.open({
          type: 'success',
          content: 'Thank you for registering!',
          className: 'custom-class-message',
        });
        setIsRegistered(true); // Mark as registered
      })
      .catch((error) => {
        console.error("Error:", error);
        messageApi.open({
          type: 'error',
          content: 'Registration failed. Please try again.',
          className: 'custom-class-message',
        });
        // message.error("Registration failed. Please try again.");
      })
      .finally(() => {
        setLoading(false); // Stop loading
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const validateEmail = (_, value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (value && !emailRegex.test(value)) {
      return Promise.reject("Invalid email address");
    }
    return Promise.resolve();
  };

  const validatePhoneNumber = (_, value) => {
    const phoneRegex = /^\d{10}$/;
    if (value && !phoneRegex.test(value)) {
      return Promise.reject("Invalid phone number");
    }
    return Promise.resolve();
  };
  console.log('videoheight', videoHeight);

  return (
    <div id="signup" ref={contactRef}>
      {/* <video
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="background-video"
        >
          <source src={bgDesktopVideo} type="video/mp4" />
        </video> */}
      <div className="full-width-contact" ref={formRef}>
        <div className="row" style={{ width: '100%', display: 'inline' }}>
          <div className="col-sm-0 col-md-2"></div>
          <div className="col-sm-12 col-md-8">
            {/* <ScrollAnimation animateIn="bounceInRight" animateOut="bounceOutLeft"> */}
            <div className="row">
              <div className="section-title">
                {!isRegistered && <h2>SIGN UP TO REGISTER</h2>}
              </div>

              {!isRegistered ? ( // Show form only if not registered
                <Form
                  className="regformbox"
                  name="yourForm"
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{ rsvp: true }}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Row gutter={16}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label={<span style={{ color: "white" }}>Name</span>}
                        name="name"
                        rules={[{ required: true, message: "Please enter your name" }]}
                      >
                        <Input placeholder="Enter your name" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        label={<span style={{ color: "white" }}>Official email</span>}
                        name="email"
                        rules={[
                          { required: true, message: "Please enter your official email" },
                          { validator: validateEmail },
                        ]}
                      >
                        <Input placeholder="Enter your official email" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        label={<span style={{ color: "white" }}>Designation</span>}
                        name="designation"
                        rules={[
                          { required: true, message: "Please enter your designation" },
                        ]}
                      >
                        <Input placeholder="Enter your designation" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        label={<span style={{ color: "white" }}>Phone Number</span>}
                        name="phoneNumber"
                        rules={[
                          { required: true, message: "Please enter your phone number" },
                          { validator: validatePhoneNumber },
                        ]}
                      >
                        <Input placeholder="Enter your phone number" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        label={<span style={{ color: "white" }}>
                          Which type of partner do you represent?
                        </span>}
                        name="partnerType"
                        rules={[{ required: true, message: "Please select your partner type" }]}
                      >
                        <Select placeholder="Select">
                          <Option value="brand">Brand</Option>
                          <Option value="agency">Agency</Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        label={<span style={{ color: "white" }}>Organisation Name</span>}
                        name="organizationName"
                        rules={[{ required: true, message: "Please enter your organisation name" }]}
                      >
                        <Input placeholder="Enter your organisation name" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        label={<span style={{ color: "white" }}>
                          Which brand are you representing?
                        </span>}
                        name="brandRepresentation"
                      >
                        <Input placeholder="Enter the brand name" />
                      </Form.Item>
                    </Col>

                    {/* <Col xs={24}>
                      <Form.Item
                        name="rsvp"
                        valuePropName="checked"
                        rules={[
                          {
                            validator: (_, value) =>
                              value
                                ? Promise.resolve()
                                : Promise.reject(
                                  new Error("You must confirm your RSVP")
                                ),
                          },
                        ]}
                      >
                        <Checkbox>
                          I’m confirming my RSVP for Flipkart Connect—see you there!
                        </Checkbox>
                      </Form.Item>
                    </Col> */}

                    <Col xs={24} md={24}>
                      <Form.Item
                        label={<span style={{ color: "white" }}>Email of the POC</span>}
                        name="pocEmail"
                        rules={[{ validator: validateEmail }]}
                      >
                        <Input placeholder="Enter the email of your Flipkart Ads POC" />
                      </Form.Item>
                    </Col>

                    <Col xs={24}>
                      <Form.Item className="text-center">
                        <Button
                          type="primary"
                          className="contactregisterbtn"
                          htmlType="submit"
                          loading={loading}
                        >
                          {loading ? "Registering..." : "Register"}
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              ) : (
                <div className="thank-you-message text-center">
                  <h3 style={{ color: 'fff', fontSize: '28px', fontWeight: 'bold' }}>Thank you for registering!</h3>
                  <br />
                  <br />
                  <div className="text-center">
                    <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                      <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                      <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                    </svg>
                  </div>
                  <br />
                  <br />

                  <p className="text-center">Your registration for Flipkart Connect 2026 has been received and is currently under review.
                    <br />
                    Further updates will be shared from <a href="mailTo:support@flipkartconnect2026.com">support@flipkartconnect2026.com</a>.<br />  If you don’t see the email, please check your spam folder or reach out to your Ads Sales POC.</p>
                </div>
              )}
            </div>
            {/* </ScrollAnimation> */}
          </div>
          <div className="col-sm-0 col-md-2 "></div>
        </div>
      </div>
    </div>
  );
};
